import { mapGetters, mapActions } from 'vuex';
import marketChangePrice from '@/components/market/market-change-price/market-change-price.vue';
import { isMarketSingle, marketUserGainLoss } from '@/utils/helpers';
import { MODALS } from '@/components/app/app-modals/app-modals';

export default {
  components: {
    marketChangePrice,
  },
  props: {
    market: {
      type: Object,
      required: true,
    },
    theme: {
      type: String,
      required: false,
      default: '',
    },
    showLabels: {
      type: Boolean,
      default: true,
    },
    showMarketLink: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
    ...mapGetters('user', ['isLoggedIn']),
    userGainLoss() {
      return marketUserGainLoss(this.market);
    },
    isAllPayoutsAvailable() {
      return !isMarketSingle(this.market);
    },
    gainIndicatorClassModifier() {
      return {
        'market-payout-sushi__gain': true,
        'market-payout-sushi__going-down': !this.userGainLoss,
      };
    },
    classModifiers() {
      return {
        'market-payout-sushi': true,
        [`market-payout-sushi--${this.theme}`]: this.theme,
      };
    },
    gainLossLabel() {
      return this.userGainLoss >= 0 ? 'Gain' : 'Loss';
    },
  },
  methods: {
    ...mapActions('popup', ['setGenericPopup']),
    allPayouts() {
      // because there is no routing for modals
      this.setGenericPopup({
        name: MODALS.POTENTIAL_PAYOUTS,
        options: {
          market: this.market,
        },
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-payout-sushi/market-payout-sushi.js